import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class ReshapeImageAction extends AbstractProvidedClass {
    isImageAction = true;
    anchor;

    constructor(provider, anchor) {
        super(provider);

        this.anchor = anchor;
        this.oldX = this.image.absX;
        this.oldY = this.image.absY;
        this.oldWidth = this.image.displayWidth;
        this.oldHeight = this.image.displayHeight;
    }

    update() {
        this.anchor.move();
    }

    finish() {
        this.newX = this.image.absX;
        this.newY = this.image.absY;
        this.newWidth = this.image.displayWidth;
        this.newHeight = this.image.displayHeight;
        this.actions.finish();
    }

    undo() {
        this.image.absX = this.oldX;
        this.image.absY = this.oldY;
        this.image.updateCorners(this.oldWidth, this.oldHeight);
    }

    redo() {
        this.image.absX = this.newX;
        this.image.absY = this.newY;
        this.image.updateCorners(this.newWidth, this.newHeight);
    }
}
